import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React, { useImperativeHandle, useState } from 'react';
import Notice from './notice';
var seed = 0;
var now = Date.now();

function getUuid() {
  var _context;

  var id = seed;
  seed += 1;
  return _concatInstanceProperty(_context = "msg_".concat(now, "_")).call(_context, id);
}

var Notification = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var placement = props.placement;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      notices = _useState2[0],
      setNotices = _useState2[1];

  useImperativeHandle(ref, function () {
    return {
      add: add,
      remove: remove,
      placement: placement,
      notices: notices
    };
  }, [notices]);

  var add = function add(addProps) {
    var key = addProps.key || getUuid();

    var notice = _extends(_extends({}, addProps), {
      key: key
    });

    var pns = _toConsumableArray(notices);

    var updatedNotices = _concatInstanceProperty(pns).call(pns);

    var noticeIndex = _mapInstanceProperty(pns).call(pns, function (v) {
      return v.key;
    }).indexOf(key);

    if (~noticeIndex) {
      _spliceInstanceProperty(updatedNotices).call(updatedNotices, noticeIndex, 1, notice);
    } else {
      updatedNotices.push(notice);
    }

    setNotices(updatedNotices);
  };

  var remove = function remove(key) {
    setNotices(function (preNotices) {
      return _filterInstanceProperty(preNotices).call(preNotices, function (notice) {
        return notice.key !== key;
      });
    });
  };

  var _onClose = function onClose(notice) {
    remove(notice.key || '');
    notice.onClose && notice.onClose(notice.key);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, _mapInstanceProperty(notices).call(notices, function (notice) {
    return /*#__PURE__*/React.createElement(Notice, _extends({}, notice, {
      key: notice.key,
      onClose: function onClose() {
        return _onClose(notice);
      }
    }));
  }));
});
Notification.displayName = 'Notification';
export default Notification;